<script setup lang="ts">
import { RouterView, useRoute } from '@hfc/ui-core';
import { computed } from 'vue';
import DefaultPage from '@/shared/infrastructure/layouts/DefaultPage.vue';
import HomePage from '@/shared/infrastructure/layouts/HomePage.vue';

const route = useRoute();

const layouts = [
  {
    name: 'DefaultPage',
    component: DefaultPage
  },
  {
    name: 'HomePage',
    component: HomePage
  }
];

const layout = computed(() => layouts.find(layout => layout.name === route.meta.layout)?.component || DefaultPage);
</script>

<template>
  <div>
    <component :is="layout">
      <RouterView />
    </component>
  </div>
</template>
